import { Hoja } from "@/components/Hoja";
import { LEGAL_NOTICE } from "@/lib/legal";
import { LegalDoc } from "@/components/LegalDoc";

const POINTS = [
  ["Tus entradas están cifradas", "Se guardan cifradas con una clave propia de tu cuenta. Solo tú las lees en Pensive; nadie más puede abrirlas desde la app."],
  ["Lo que envías a Remanso se procesa con IA", "Cuando tocas Acompáñame o Cerrar la entrada, el texto de esa entrada se envía a un modelo de inteligencia artificial para que Remanso pueda responder."],
  ["El tono de tu texto se analiza mientras escribes", "Para la regla de los 15 minutos, cada cierto tiempo se analiza el tono de lo que escribes. Así Remanso puede asomarse si llevas un rato en algo difícil."],
  ["Puedes borrar tu cuenta y todos tus datos", "Desde Mi cuenta puedes exportar lo que escribiste y borrar tu cuenta, tus entradas, tus hábitos y sus registros, para siempre."],
];

export default function Privacidad() {
  return (
    <Hoja testId="screen-privacidad" title="Privacidad">
      <div className="max-w-3xl space-y-6">
        {POINTS.map(([title, text], i) => (
          <section key={title} data-testid={`privacy-point-${i}`}>
            <h2 className="font-serif text-[22px] leading-tight text-tinta">{title}</h2>
            <p className="text-[15px] text-sec leading-relaxed mt-1.5">{text}</p>
          </section>
        ))}
        <section className="pt-6 border-t border-linea" data-testid="privacy-legal">
          <h2 className="font-serif text-[22px] leading-tight text-tinta">Aviso de privacidad</h2>
          {LEGAL_NOTICE
            ? <div className="mt-3"><LegalDoc text={LEGAL_NOTICE} testId="privacy-legal-text" /></div>
            : <p className="mt-2 rounded-[8px] border-[1.5px] border-dashed border-borde p-4 text-[14px] text-meta" data-testid="privacy-legal-placeholder">Aquí irá el aviso de privacidad legal.</p>}
        </section>
      </div>
    </Hoja>
  );
}
